export default {
  Small: 640,
  Medium: 1024,
  Large: 1200
}
